<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Motivos de devolución
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Motivos de devolución</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form [formGroup]='formHeader' novalidate autocomplete="off">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-header justify-content-end" style="border-bottom: 1px solid #dee2e6">

        <button type="button" mdbBtn color="info" (click)="openModalMotivo()" size="sm" mdbWavesEffect>
          Agregar
        </button>
      </div>
      <div class="row filtros-body align-content-center">

        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <div class="md-form">
              <input formControlName="descripcion" type="text" id="desc" class="form-control" placeholder="Descripción"
                #desc />
              <label for="desc">Descripción</label>
            </div>
          </div>
        </div>
        <div class="col align-items-center" style="display: flex;">
          <!-- Material inline 1 -->
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="materialInline1" name="busquedaEstado"
              formControlName="busquedaEstado" [value]="RB_ESTADO_ACTIVOS" mdbInput />
            <label class="form-check-label" for="materialInline1">Activos</label>
          </div>

          <!-- Material inline 2 -->
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="materialInline2" name="busquedaEstado"
              formControlName="busquedaEstado" [value]="RB_ESTADO_INACTIVOS" mdbInput />
            <label class="form-check-label" for="materialInline2">Inactivos</label>
          </div>

          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="materialInline3" name="busquedaEstado"
              formControlName="busquedaEstado" [value]="RB_ESTADO_TODOS" mdbInput />
            <label class="form-check-label" for="materialInline3">Todos</label>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn color="secondary" size="sm" mdbWavesEffect (click)="buscar()">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive" *ngIf="listaMovimientos">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>

            <th scope="col">Descripción</th>
            <th scope="col">Estado</th>
            <th scope="col">Bodega asociada</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && listaMovimientos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let motivo of listaMovimientos">

            <td>{{motivo.descripcion}}</td>
            <td>
              <div *ngIf="motivo.activo">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!motivo.activo">
                <mdb-badge pill="false" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>{{motivo.nombrebodega}}</td>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                mdbTooltip="Editar" (click)="editar(motivo)" placement="right">
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
              <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect mdbTooltip="Activar"
                placement="right" *ngIf="!motivo.activo" (click)="activar(motivo)">
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <button class="btn-actions-sm" color="success" mdbBtn type="button" mdbWavesEffect mdbTooltip="Desactivar"
                placement="right" *ngIf="motivo.activo" (click)="desactivar(motivo)">
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar e Editar Familia -->
<app-motivo-devolucion-modal-add-edit (onAddEdit)="onAddEdit($event)"></app-motivo-devolucion-modal-add-edit>